import React from 'react';
import { ReactionConfigContext } from './reaction-config-context';
export const ReactionConfigProvider = (props) => {
    return (React.createElement(ReactionConfigContext.Provider, { value: props.config }, props.children));
};
export default ReactionConfigProvider;
//# sourceMappingURL=reaction-config-provider.js.map